// DAC TaskHub — Revision History
// Versioning: v1.MINOR.PATCH  (minor = new features, patch = fixes)

export const CHANGELOG = [
  {
    version: "v1.7",
    date: "2026-03-31",
    title: "Outlook Add-in",
    type: "feature",
    changes: [
      "Outlook Add-in: Create TaskHub tasks directly from emails — subject, sender, and email link pre-filled automatically",
    ],
  },
  {
    version: "v1.6",
    date: "2026-03-30",
    title: "Search, Help & Revision History",
    type: "feature",
    changes: [
      "Global task search (Ctrl+K) — searches title, description, notes, tags",
      "Help & Guide modal with tabbed reference (Tasks, Assignment, Views, Tips)",
      "Revision history / changelog (this screen)",
      "Completed task toggle in Work Queue and Company Tasks",
      "DAC Robotics logo in sidebar and login screen",
      "Mobile responsive layout restored — bottom nav, full-screen detail",
    ],
  },
  {
    version: "v1.5",
    date: "2026-03-29",
    title: "Assignment Visibility & Approval Flow",
    type: "feature",
    changes: [
      "Dashboard: 'Assigned to Me' section with inline Accept/Decline buttons",
      "Dashboard: 'Tasks I've Assigned' section with acceptance status badges",
      "Dashboard: 'Needs Your Approval' section for task owners",
      "New 'Needs Approval' status — assigned tasks require owner sign-off before closing",
      "Approve & Close / Reopen buttons in Detail panel and Dashboard",
      "Daily digest email now shows assigned-from/assigned-to context per task",
      "Fixed completed tasks lingering in Work Queue after edit-form save",
    ],
  },
  {
    version: "v1.4",
    date: "2026-03-28",
    title: "Mobile Responsive Layout",
    type: "feature",
    changes: [
      "Mobile bottom navigation bar with badges",
      "Mobile top bar with logo, view title, and quick-add button",
      "Task detail panel opens full-screen on mobile",
      "Sidebar hidden on mobile (desktop only)",
      "Safe-area insets for iPhone notch and home bar",
    ],
  },
  {
    version: "v1.3",
    date: "2026-03-27",
    title: "Daily Digest Email",
    type: "feature",
    changes: [
      "Azure Functions timer trigger — sends digest at 7 AM weekdays (CST)",
      "Per-user personalized HTML email grouped by date horizon",
      "Stats header: Past Due · Yesterday · Today · Tomorrow · Total",
      "Company tasks section with project and owner/assignee display",
      "Project display: CustomerName · JobNumber – ProjectName format",
      "Admin DigestTester — My Digest Only / All Users to my email",
      "HTTP test endpoint for manual testing",
    ],
  },
  {
    version: "v1.2",
    date: "2026-03-20",
    title: "Daily Standup Mode",
    type: "feature",
    changes: [
      "Full-screen Daily Standup view for Managers and Admins",
      "Standup flag on tasks — amber highlight when update is overdue",
      "Standup history log per task — date, status, note, updatedAt",
      "Standup toggle and note-save wired through App.jsx",
    ],
  },
  {
    version: "v1.1",
    date: "2026-03-10",
    title: "Roles, Admin & Team View",
    type: "feature",
    changes: [
      "Role-based access: Admin, Manager, User",
      "Admin page — user management, notification settings",
      "Team View for managers — direct reports' non-personal tasks",
      "Act As (impersonation) for admins",
      "Task acceptance flow — Inbox with Accept/Decline",
      "Recurring tasks — daily, weekly, biweekly, monthly, custom interval",
      "Task dependencies — lock tasks until prerequisites complete",
    ],
  },
  {
    version: "v1.0",
    date: "2026-02-15",
    title: "Initial Release",
    type: "release",
    changes: [
      "Core task management — create, edit, delete, complete",
      "SharePoint backend (TaskHub_Tasks, TaskHub_Company, TaskHub_Users)",
      "Microsoft 365 / Azure AD authentication (MSAL)",
      "Personal, Assigned, and Company visibility levels",
      "Dashboard, My Day, Work Queue, Company Tasks, Inbox views",
      "Priority (High/Medium/Low) and status badges",
      "Tags, notes, linked documents per task",
      "Azure Static Web Apps deployment with CI/CD via GitHub Actions",
    ],
  },
];

export const CURRENT_VERSION = CHANGELOG[0].version;
export const CURRENT_DATE = CHANGELOG[0].date;
